@if (testVariant && rendering) {
  <wl-component-testing
    [variant]="testVariant"
    [rendering]="rendering"
    (rendered)="variantRendered($event)"
  >
  </wl-component-testing>
}
